import React, { useEffect, useState } from "react";
import { Formik, Form, Field } from "formik";
import { Button, MenuItem, TextField, Box, Typography, Select } from "@mui/material";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import "react-toastify/dist/ReactToastify.css";
import useApiCaller from "hooks/apiCaller";

const DownloadDeclarationReportForm = ({ onTrigger }) => {
  const [declarations, setDeclarations] = useState([]);
  const apiCaller = useApiCaller();

  useEffect(() => {
    const fetchDeclarations = async () => {
      try {
        const response = await apiCaller.post("/super-user/fetchAllDeclarationsCreatedByAd");
        if (response) {
          setDeclarations(response?.data?.data?.result || []);
        }
      } catch (error) {
        console.error("Error fetching declarations:", error);
      }
    };
    fetchDeclarations();
  }, []);

  const downloadExcel = (jsonData,fileName) => {
    if (!jsonData || jsonData.length === 0) {
      console.warn("No data available to download.");
      return;
    }
  
    const worksheet = XLSX.utils.json_to_sheet(jsonData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Declarations");
    XLSX.writeFile(workbook, `${fileName}_Submission_Report.xlsx`);
  };

  const handleSubmit = async (values) => {
    console.log("Form Submitted:", values);
    
    try {
      const response = await apiCaller.post("/super-user/fetch-declaration-reports", values);
      if (response) {
        let jsonData = response?.data?.data?.result;
        downloadExcel(jsonData, values.declarationName);
        toast.success("Reports Downloaded", { theme: "colored" });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error(`Failed to Download reports ${error.message}`);
    }
  };

  return (
    <>
      <Formik
        initialValues={{
          declarationName: "",
        }}
        onSubmit={handleSubmit}
      >
        {({ setFieldValue }) => (
          <Form>
            <Field
              as={Select}
              name="declarationName"
              label="Select Declaration"
              fullWidth
              margin="normal"
              displayEmpty
              onChange={(event) => setFieldValue("declarationName", event.target.value)}
            >
              <MenuItem value="" disabled>
                Select Declaration
              </MenuItem>
              {declarations.map((item) => (
                <MenuItem key={item.courseName} value={item.courseName}>
                  {item.courseName}
                </MenuItem>
              ))}
            </Field>

            <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 2 }}>
              Download
            </Button>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default DownloadDeclarationReportForm;
